import { runProPagesSmartSubnav } from '../../snippets/pro-pages-smart-subnav/pro-pages-smart-subnav';

window.onReady(() => {
  runProPagesSmartSubnav({
    intersectionThreshold: [0, 0.3],
    intersectionRatio: 0.3,
  });
});
